<template>
  <div class="q-col-12"
       :class="{'q-col-12 q-col-lg-12 q-col-xl-9 q-ps-1': promotedProductEnabled && canShowPromotedSection, 'q-col-12': !promotedProductEnabled && !canShowPromotedSection}">
    <div class="q-row">
      <p class="popular-products__header q-col-lg-12 q-text-muted q-fw-semibold" v-if="!isMobileView && productsList.length > 0">
        {{ productsHeader }}
      </p>
      <template v-for="item in productsList" :key="item.id || item.url">
        <SingleProduct v-if="item.type !== 'custom'" :result="item" :customTemplate="customTemplate" />
        <CustomLink v-else :url="item.url" :label="item.label" />
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import SingleProduct from './SingleProduct.vue';
import CustomLink from './CustomLink.vue'; // Dodaj import nowego komponentu

import { defineProps, inject, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useMobileViewStore } from '@/store/MobileViewStore';
import { SmartSearchConfigInterface } from '@/core/types';

// Definicja props
defineProps(['productsList', 'productsHeader', 'promotedProductEnabled', 'canShowPromotedSection']);

// Pobieramy customTemplate z konfiguracji (np. autocompleteSingleResult)
const SmartSearchConfig = ref(inject<SmartSearchConfigInterface>('SmartSearchConfig')!)
const customTemplate = SmartSearchConfig?.value?.serp?.customComponents?.autocompleteSingleResult;

const mobileViewStore = useMobileViewStore();
const { isMobileView } = storeToRefs(mobileViewStore);
</script>